import React, { Component } from 'react';
import { connect } from 'dva';
import { Link } from 'dva/router';
import { Form, Icon, Input, Button, Alert, Spin } from 'antd';
import classNames from 'classnames';
import styles from './Login.less';

const FormItem = Form.Item;

@connect(({ login, loading }) => ({
  errorMsg: login.errorMsg,
  submitting: loading.effects['login/login'] === true,
}))
@Form.create()
export default class LoginPage extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateFields = this.validateFields.bind(this);
  }

  componentWillUnmount() {
    this.props.dispatch({ type: 'login/resetState' });
  }

  handleSubmit = e => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        const keys = Object.keys(err);
        const errorMsg = err[keys[0]].errors[0].message;
        this.props.dispatch({
          type: 'login/setErrorMsg',
          errorMsg,
        });

        return;
      }

      this.props.dispatch({
        type: 'login/setErrorMsg',
        errorMsg: null,
      });

      this.props.dispatch({
        type: 'login/login',
        payload: {
          account: values.account,
          password: values.password,
        },
      });
    });
  };

  validateFields(fieldName, { success, failure } = {}) {
    setTimeout(() => {
      const { form } = this.props;

      form.validateFields([fieldName], err => {
        if (err) {
          const keys = Object.keys(err);
          const errorMsg = err[keys[0]].errors[0].message;
          this.props.dispatch({
            type: 'login/setErrorMsg',
            errorMsg,
          });

          if (failure) {
            failure(errorMsg);
          }

          return;
        }

        this.props.dispatch({
          type: 'login/setErrorMsg',
          errorMsg: null,
        });

        if (success) {
          success();
        }
      });
    }, 100);
  }

  render() {
    const { errorMsg, submitting } = this.props;
    const { getFieldDecorator } = this.props.form;

    return (
      <div className={styles.root}>
        <Spin spinning={submitting}>
          <p className="title">校之付后台登录</p>
          <Form onSubmit={this.handleSubmit} className="login-form">
            <FormItem className="field-wrap">
              {getFieldDecorator('account', {
                onChange: () => {
                  this.validateFields('account');
                },
                rules: [{ required: true, message: '请输入账号' }],
              })(
                <Input
                  prefix={<Icon type="user" className="input-icon" />}
                  placeholder="账号"
                  onBlur={() => {
                    this.validateFields('account');
                  }}
                />
              )}
            </FormItem>

            <FormItem className="field-wrap">
              {getFieldDecorator('password', {
                onChange: () => {
                  this.validateFields('password');
                },
                rules: [{ required: true, message: '请输入密码' }],
              })(
                <Input
                  prefix={<Icon type="lock" className="input-icon" />}
                  type="password"
                  placeholder="密码"
                  onBlur={() => {
                    this.validateFields('password');
                  }}
                />
              )}
            </FormItem>

            <FormItem className="operation-wrap">
              <div
                className={classNames({
                  'forgot-wrap': true,
                  error: errorMsg,
                })}
              >
                {errorMsg && <Alert message={errorMsg} type="error" showIcon />}
                <Link to="/user/forget">忘记密码？</Link>
              </div>
              <div className="button-wrap">
                <Button type="primary" htmlType="submit" className="login-button">
                  登录
                </Button>
              </div>
            </FormItem>
          </Form>
        </Spin>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/User/Login.js